import { useLocalStorage } from '#pplx/frontend/browser-storage/hooks/useLocalStorage.js';
export function usePartnerCode() {
    const [value, setValue] = useLocalStorage('pplx.partner_banner', null);
    return [value, setValue];
}
//# sourceMappingURL=usePartnerCode.js.map